export enum PrintInstructionType {
  SELL = 1,
  TURN = 2,
}

export enum PrintInstructionId {
  POS = 'ticket-invoice-by-pos',
  SELL = 'ticket-invoice-by-order',
  ORDER_DETAIL = 'modal-confirm-order-ticket',
  TURN = 'ticket-turn-report',
}

export enum PrinterTextSizesEnum {
  SMALL = 'sm',
  MEDIUM = 'md',
  LARGE = 'lg',
}

export const printerTextSizes = {
  [PrinterTextSizesEnum.SMALL]: { value: PrinterTextSizesEnum.SMALL, label: 'Pequeño' },
  [PrinterTextSizesEnum.MEDIUM]: { value: PrinterTextSizesEnum.MEDIUM, label: 'Mediano' },
  [PrinterTextSizesEnum.LARGE]: { value: PrinterTextSizesEnum.LARGE, label: 'Grande' },
}

export const printerTextSizesArray: ISelect[] = Object.values(printerTextSizes)

export enum PrintConnectionTypeEnum {
  WEB = 'web',
  DIGIT = 'digital',
  EPSON = 'epson',
  ESC_POS = 'esc/pos',
  BLUETOOTH = 'bluetooth',
  USB = 'usb',
}

export const printConnectionTypes = {
  [PrintConnectionTypeEnum.WEB]: { value: PrintConnectionTypeEnum.WEB, label: 'Directa' },
  [PrintConnectionTypeEnum.DIGIT]: {
    value: PrintConnectionTypeEnum.DIGIT,
    label: 'Digital',
  },
  [PrintConnectionTypeEnum.EPSON]: {
    value: PrintConnectionTypeEnum.EPSON,
    label: 'Epson',
  },
  [PrintConnectionTypeEnum.ESC_POS]: {
    value: PrintConnectionTypeEnum.ESC_POS,
    label: 'ESC/POS',
  },
  [PrintConnectionTypeEnum.BLUETOOTH]: {
    value: PrintConnectionTypeEnum.BLUETOOTH,
    label: 'Bluetooth',
  },
  [PrintConnectionTypeEnum.USB]: {
    value: PrintConnectionTypeEnum.USB,
    label: 'USB',
  },
}

export const printConnectionTypesArray: ISelect[] = Object.values(printConnectionTypes)
export const isSimplePrinter = (connectionType: string): boolean => {
  if (!connectionType) return false
  return [PrintConnectionTypeEnum.WEB, PrintConnectionTypeEnum.DIGIT].includes(
    connectionType as PrintConnectionTypeEnum,
  )
}
